import { useLanguage } from '../context/LanguageContext';
import { Mail, Phone, MapPin } from 'lucide-react';

const Impressum = () => {
  const { language } = useLanguage();

  const content = {
    en: {
      title: 'Impressum',
      subtitle: 'Legal Notice',
      company_title: 'Company Information',
      company_name: 'Exclusive Tour Transfer Dumitru',
      address_label: 'Address',
      phone_label: 'Phone',
      email_label: 'Email',
      whatsapp_label: 'WhatsApp',
      registration_title: 'Commercial Registration',
      registration_text: 'Registered in Switzerland',
      uid: 'UID (Company Number)',
      responsible_title: 'Responsible for Content',
      responsible_text: 'Exclusive Tour Transfer Dumitru',
      disclaimer_title: 'Disclaimer',
      liability_title: 'Liability for Content',
      liability_text: 'The contents of our pages were created with the greatest care. However, we cannot guarantee the accuracy, completeness, and timeliness of the content. As a service provider, we are responsible for our own content on these pages in accordance with general laws. However, we are not obligated to monitor transmitted or stored third-party information or to investigate circumstances that indicate illegal activity.',
      links_title: 'Liability for Links',
      links_text: 'Our website contains links to external third-party websites, over whose content we have no influence. Therefore, we cannot assume any liability for this third-party content. The respective provider or operator of the pages is always responsible for the content of the linked pages.',
      copyright_title: 'Copyright',
      copyright_text: 'The content and works created by the site operators on these pages are subject to Swiss copyright law. The reproduction, processing, distribution, and any kind of exploitation outside the limits of copyright law require the written consent of the respective author or creator.',
      dispute_title: 'Dispute Resolution',
      dispute_text: 'We are not willing or obliged to participate in dispute resolution proceedings before a consumer arbitration board.',
    },
    de: {
      title: 'Impressum',
      subtitle: 'Gesetzlich vorgeschriebene Angaben',
      company_title: 'Angaben gemäss Art. 3 UWG / Schweizer Impressumspflicht',
      company_name: 'Exclusive Tour Transfer Dumitru',
      address_label: 'Adresse',
      phone_label: 'Telefon',
      email_label: 'E-Mail',
      whatsapp_label: 'WhatsApp',
      registration_title: 'Handelsregister',
      registration_text: 'Eingetragen in der Schweiz',
      uid: 'UID (Firmennummer)',
      responsible_title: 'Verantwortlich für den Inhalt',
      responsible_text: 'Exclusive Tour Transfer Dumitru',
      disclaimer_title: 'Haftungsausschluss',
      liability_title: 'Haftung für Inhalte',
      liability_text: 'Die Inhalte unserer Seiten wurden mit grösster Sorgfalt erstellt. Für die Richtigkeit, Vollständigkeit und Aktualität der Inhalte können wir jedoch keine Gewähr übernehmen. Als Diensteanbieter sind wir für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Wir sind jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.',
      links_title: 'Haftung für Links',
      links_text: 'Unser Angebot enthält Links zu externen Webseiten Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich.',
      copyright_title: 'Urheberrecht',
      copyright_text: 'Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem Schweizer Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung ausserhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.',
      dispute_title: 'Streitschlichtung',
      dispute_text: 'Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.',
    },
    it: {
      title: 'Impressum',
      subtitle: 'Note legali',
      company_title: 'Informazioni aziendali',
      company_name: 'Exclusive Tour Transfer Dumitru',
      address_label: 'Indirizzo',
      phone_label: 'Telefono',
      email_label: 'Email',
      whatsapp_label: 'WhatsApp',
      registration_title: 'Registro di commercio',
      registration_text: 'Registrato in Svizzera',
      uid: 'UID (Numero aziendale)',
      responsible_title: 'Responsabile del contenuto',
      responsible_text: 'Exclusive Tour Transfer Dumitru',
      disclaimer_title: 'Esclusione di responsabilità',
      liability_title: 'Responsabilità per i contenuti',
      liability_text: 'I contenuti delle nostre pagine sono stati creati con la massima cura. Tuttavia, non possiamo garantire l\'accuratezza, la completezza e l\'attualità dei contenuti. In qualità di fornitore di servizi, siamo responsabili dei nostri contenuti su queste pagine ai sensi delle leggi generali. Tuttavia, non siamo obbligati a monitorare le informazioni di terzi trasmesse o archiviate.',
      links_title: 'Responsabilità per i link',
      links_text: 'Il nostro sito web contiene link a siti web esterni di terzi, sui cui contenuti non abbiamo alcuna influenza. Pertanto, non possiamo assumerci alcuna responsabilità per questi contenuti di terzi. Il rispettivo fornitore o gestore delle pagine è sempre responsabile dei contenuti delle pagine collegate.',
      copyright_title: 'Diritto d\'autore',
      copyright_text: 'I contenuti e le opere create dagli operatori del sito su queste pagine sono soggetti al diritto d\'autore svizzero. La riproduzione, l\'elaborazione, la distribuzione e qualsiasi tipo di sfruttamento al di fuori dei limiti del diritto d\'autore richiedono il consenso scritto del rispettivo autore o creatore.',
      dispute_title: 'Risoluzione delle controversie',
      dispute_text: 'Non siamo disposti o obbligati a partecipare a procedimenti di risoluzione delle controversie dinanzi a un organismo di conciliazione dei consumatori.',
    },
  };

  const t = content[language] || content.en;

  return (
    <div className="min-h-screen pt-24 pb-16 bg-[#0A0A0A]" data-testid="impressum-page">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-12">
          <p className="uppercase text-xs tracking-[0.3em] text-[#D4AF37] mb-4">{t.subtitle}</p>
          <h1
            className="text-3xl sm:text-4xl lg:text-5xl font-light text-white"
            style={{ fontFamily: 'Cormorant Garamond, serif' }}
            data-testid="impressum-title"
          >
            {t.title}
          </h1>
        </div>

        <div className="space-y-10">
          {/* Company Info */}
          <section className="bg-[#121212] border border-white/10 p-8">
            <h2 className="text-xl text-[#D4AF37] mb-6" style={{ fontFamily: 'Cormorant Garamond, serif' }}>
              {t.company_title}
            </h2>
            <div className="space-y-4">
              <p className="text-white text-lg font-semibold">{t.company_name}</p>
              <div className="flex items-start gap-3 text-[#A1A1AA]">
                <MapPin className="w-4 h-4 text-[#D4AF37] mt-1 flex-shrink-0" />
                <span className="text-sm">Bahnhofstrasse 1<br />8560 Marstetten<br />Switzerland</span>
              </div>
              <div className="flex items-center gap-3 text-[#A1A1AA]">
                <Phone className="w-4 h-4 text-[#D4AF37] flex-shrink-0" />
                <a href="tel:+41799270731" className="text-sm hover:text-[#D4AF37] transition-colors">+41 79 927 07 31</a>
              </div>
              <div className="flex items-center gap-3 text-[#A1A1AA]">
                <Mail className="w-4 h-4 text-[#D4AF37] flex-shrink-0" />
                <a href="mailto:etourtransfer@gmail.com" className="text-sm hover:text-[#D4AF37] transition-colors">etourtransfer@gmail.com</a>
              </div>
            </div>
          </section>

          {/* Registration */}
          <section className="bg-[#121212] border border-white/10 p-8">
            <h2 className="text-xl text-[#D4AF37] mb-4" style={{ fontFamily: 'Cormorant Garamond, serif' }}>
              {t.registration_title}
            </h2>
            <p className="text-[#A1A1AA] text-sm mb-2">{t.registration_text}</p>
            <p className="text-white text-sm"><span className="text-[#A1A1AA]">{t.uid}:</span> CHE-468.004.384</p>
          </section>

          {/* Responsible */}
          <section className="bg-[#121212] border border-white/10 p-8">
            <h2 className="text-xl text-[#D4AF37] mb-4" style={{ fontFamily: 'Cormorant Garamond, serif' }}>
              {t.responsible_title}
            </h2>
            <p className="text-[#A1A1AA] text-sm">{t.responsible_text}</p>
            <p className="text-[#A1A1AA] text-sm">Bahnhofstrasse 1, 8560 Marstetten, Switzerland</p>
            <p className="text-[#A1A1AA] text-sm">etourtransfer@gmail.com</p>
          </section>

          {/* Disclaimer */}
          <section className="bg-[#121212] border border-white/10 p-8 space-y-6">
            <h2 className="text-xl text-[#D4AF37] mb-4" style={{ fontFamily: 'Cormorant Garamond, serif' }}>
              {t.disclaimer_title}
            </h2>
            <div>
              <h3 className="text-white text-sm font-semibold mb-2">{t.liability_title}</h3>
              <p className="text-[#A1A1AA] text-sm leading-relaxed">{t.liability_text}</p>
            </div>
            <div>
              <h3 className="text-white text-sm font-semibold mb-2">{t.links_title}</h3>
              <p className="text-[#A1A1AA] text-sm leading-relaxed">{t.links_text}</p>
            </div>
            <div>
              <h3 className="text-white text-sm font-semibold mb-2">{t.copyright_title}</h3>
              <p className="text-[#A1A1AA] text-sm leading-relaxed">{t.copyright_text}</p>
            </div>
            <div>
              <h3 className="text-white text-sm font-semibold mb-2">{t.dispute_title}</h3>
              <p className="text-[#A1A1AA] text-sm leading-relaxed">{t.dispute_text}</p>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default Impressum;
